import { vObject, type vOutput, vPicklist } from '../validation/index.ts'

export const serializedLoadOutputFormats = [
  'shipment',
  'rating',
  'tracking',
  'dispatching',
  'documents',
  'profinder',
  'invoice',
] as const
export type SerializedLoadOutputFormat =
  (typeof serializedLoadOutputFormats)[number]

export const serializedLoadOutputSchema = vObject({
  output: vPicklist(serializedLoadOutputFormats),
})

export type SerializedLoadOutputQuery = vOutput<
  typeof serializedLoadOutputSchema
>
